export enum PasswordClassification {
  WEAK = 'fraca',
  MEDIUM = 'média',
  STRONG = 'forte',
  SAFE = 'segura',
}
